<template>
<el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div style="" class="cs-fullHeight cs-contentContainer-right">
            <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                <el-row>
                    <el-col>
                        <span class="cs-title">上课签到</span>
                        <el-row>
                            <el-col :span="18">
                                <el-button type="text" @click="onBack">返回</el-button>
                            </el-col>
                        </el-row>
                        <el-row class="grid-content">
                            <student-sign-detail :signDetails="signCourseDetail" :course="course" :usage="usage"></student-sign-detail>
                        </el-row>
                        <el-row>
                            &nbsp;
                        </el-row>
                        <el-row>
                            <student-sign-summary v-loading="loadingSignSummary" :signSummary="signSummary"></student-sign-summary>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-col>
</el-row>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .grid-content {
        margin-top: 15px;
        .cs-schedule-buttonContainer {
            text-align: right;
        }
    }
    .cs-schedule-bottomButton {
        margin-top: 20px;
    }
}
</style>

<script>
import navigator from "../components/navigator";
import studentSignDetail from "../components/studentSignDetail";
import studentSignSummary from "../components/studentSignSummary";
import {getStudentSignDetail,getStudentSignSummary} from "../service/student.service.js";

export default {
    data() {
        return {
            teacherId: 0,
            courseId: 0,
            signCourseDetail:[],
            loadingSignSummary: false,
            course:{
                CourseName:"",
                TeacherName:"",
                IsActive:true,
                CourseCategory: ""
            },
            signSummary:{
                AttendRateText:'',
                AbsentCount:'',
                TruancyCount:'',
                LateCount:'',
                TotalAbsentMinutes:''
            },
            usage: 'student'
        };
    },
    created() {
        this.getParams();
        this.initData();
    },
    components: {
        navigator,studentSignDetail,studentSignSummary
    },
    methods: {
        initData() { 
            getStudentSignDetail(
                this.teacherId,
                this.courseId
            ).then(result => {
                if (!!result && result.success) {
                    this.signCourseDetail = result.data; 
                } 
                else{
                    this.$message.error(result.message);
                }
            });
            this.loadingSignSummary = true;
            getStudentSignSummary(
                this.teacherId,
                this.courseId
            ).then(result => {
                if (!!result && result.success) {
                     this.signSummary = result.data;
                     this.course.CourseName = result.data.CourseName;
                     this.course.TeacherName = result.data.TeacherName;
                     this.course.IsActive = result.data.IsActive;
                     this.course.CourseCategory = result.data.CourseCategory;
                } 
                else{
                    this.$message.error(result.message);
                }
                this.loadingSignSummary = false;
            });
        },
        getParams() {
            this.teacherId = this.$route.query.teacherId;
            this.courseId = this.$route.query.courseId;
            this.usage = this.$route.query.usage;
        },
        onBack(){
            this.$router.push("../signCourse");
        }
    },
    watch: {
        '$router': function () {
            this.getParams();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/signDetail.vue